import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { PRIVACY_POLICY_PATH } from '../constants/legalPaths';

/**
 * Mandatory GDPR consent for quote / contact forms (HU baseline + EN/RO via i18n).
 */
export default function GdprConsentCheckbox({ id, checked, onChange }) {
  const { t } = useI18n();

  return (
    <label className="qf-check-block">
      <input
        id={id}
        name={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required
      />
      <span>
        {t('gdpr_consent_before')}{' '}
        <Link to={PRIVACY_POLICY_PATH}>{t('gdpr_consent_link')}</Link>
        {t('gdpr_consent_after')}
      </span>
    </label>
  );
}
